import React from 'react';
import { getSettings } from '../../util/getSettings';
import classnames from 'classnames';
import { QsStateManager } from '../../util/urls';

const StateFilter = () => {
  const settings = getSettings(['century', 'settings']);
  const states = settings.searchRegionStates;
  const searchString = new QsStateManager().getSearchString();

  return (
    <div className="stateFilter">
      <div id="state_filter_simplemap" className="simple-map"></div>
      <div className="state-links-container">
        <ul className="state-links">
          {states.map((state, idx) => (
            <li key={idx}>
              <a
                key={idx}
                href={searchString.length ? state.RelativeURL + searchString : state.RelativeURL}
                className={classnames('state-link', { selected: state.StateCode === settings.initState })}
                aria-current={state.StateCode === settings.initState ? true : false}
              >
                {state.StateName}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default StateFilter;
